import { Helmet, HelmetProvider } from 'react-helmet-async';

import { siteLabelFromOrigin } from '@/helper/getSubDomain';

export default function JTHelmet({ description = 'Jungle Toppings', content = 'Jungle Toppings' }) {
	const jtTitle = import.meta.env.VITE_TITLE_APP;
	const siteLabel = siteLabelFromOrigin(typeof window !== 'undefined' ? window.origin : '');
	const contentTitle = `${siteLabel || 'APP'} | ${jtTitle}`;

	return (
		<HelmetProvider>
			<Helmet>
				<title>{contentTitle}</title>
				<meta name={description} content={content} />
			</Helmet>
		</HelmetProvider>
	);
}
